import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconKMSImageIcon from '../../../assets/icons/IconKMSImageIcon';
import IconKMSUpload from '../../../assets/icons/IconKMSUpload';

import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import Select from 'react-select';
import RadioTab from '../../../components/Radio/RadioTab';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import API_KMS from '../../../api/apiKMS';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import MENU_KMS from '../../../constants/menuKMSConstant';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_INSERT } from '../../../constants/menuPermissionConstant';

const validationCategory = MENU_KMS.validationCategory;

class KMSCategoryAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataKMS: {
                id: "",
                category: "",
                type: { label: "", value: "" },
                level: { label: "", value: "" },
                parentId: null,
                iconFile: null,
                lastLevel: "",
                status: "",
            },
            parentIdList: [],
            checkboxAddKMS: false,
            errorMessage: "",
            showErrorAlertResponse: false,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showPopupImage: false,
            disableKMSListMenu: true,
            showAlertKMSCategory: false,
            showAlertKMSCategoryRegex: false,
            showAlertKMSCategoryMaxChar: false,
            showAlertType: false,
            showAlertLevel: false,
            showAlertParent: false,
        }
        this.containerRef = createRef();
    }

    componentDidMount() {
        this.setState({ disableKMSListMenu: true });
        let setDefaultValueLastLevel = "true";
        let setDefaultValueStatus = "true";
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                lastLevel: setDefaultValueLastLevel,
                status: setDefaultValueStatus,
            },
            disableKMSListMenu: true,
        })
    }

    redirectToKMSPage = () => {
        this.props.history.goBack();
    }

    handleChange = e => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleChangeType = data => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                type: data
            }
        })
    }

    handleChangeLevel = data => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                level: data,
                parentId: null,
            }
        },
            () => {
                if (data.value !== 1) {
                    this.getParentListByLevel(1, 100, (data.value - 1));
                }
            }
        );
    }

    handleChangeParent = data => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                parentId: data
            }
        })
    }

    handleChangeAttachment = e => {
        let tempFile = e.target.files[0];

        if (!tempFile) {
            e.target.value = null;
            return
        }

        if (tempFile.type !== "image/jpeg" && tempFile.type !== "image/png" && tempFile.type !== "image/jpg") {
            e.target.value = null;
            return this.setState({
                errorMessage: "File yang dipilih bukan file gambar (JPEG, PNG & JPG). silahkan pilih file lain",
                showErrorAlertResponse: true
            });
        }

        if (tempFile.size / 1024 / 1024 >= 2) {
            e.target.value = null;
            return this.setState({
                errorMessage: `Maksimal Ukuran file 2Mb!`,
                showErrorAlertResponse: true
            });
        }

        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                iconFile: tempFile,
            }
        });
    }

    handleCheck = e => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleCheckboxAddKMS = e => {
        this.setState({ checkboxAddKMS: e.target.checked })
    }

    handleSave = () => {
        // If Have error return Alert and Not Continue to the processing data and HIT API
        if (this.handleValidationField()) {
            return this.containerRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        this.setState({ showConfirmAlert: true, checkboxAddKMS: false })
    }

    handleValidationField = () => {
        let isFieldError = false;
        this.setState({
            showAlertKMSCategory: false,
            showAlertKMSCategoryRegex: false,
            showAlertType: false,
            showAlertLevel: false,
            showAlertParent: false,
            showAlertKMSCategoryMaxChar: false,
        })

        if (this.state.dataKMS.category.length > 256) {
            this.setState({ showAlertKMSCategoryMaxChar: true })
            isFieldError = true;
        }

        if (!validationCategory.test(this.state.dataKMS.category)) {
            this.setState({ showAlertKMSCategoryRegex: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.category === "") {
            this.setState({ showAlertKMSCategory: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.type.value === "") {
            this.setState({ showAlertType: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.level.value === "") {
            this.setState({ showAlertLevel: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.parentId === null && this.state.dataKMS.level.value !== 1) {
            this.setState({ showAlertParent: true })
            isFieldError = true;
        }

        return isFieldError;
    }

    handleAddCategoryKMS = () => {
        this.setState({ showConfirmAlert: false });
        let bodyFormData = new FormData();
        const data = {
            category: this.state.dataKMS.category,
            type: this.state.dataKMS.type.value,
            level: this.state.dataKMS.level.value,
            parent_id: this.state.dataKMS.parentId?.value || 0,
            last_level: this.getBooleanData(this.state.dataKMS.lastLevel),
            status: this.getBooleanData(this.state.dataKMS.status),
        }

        bodyFormData.append('photo1', this.state.dataKMS.iconFile);
        bodyFormData.append('content', JSON.stringify(data));

        API_KMS.postDataAddCategoryKMS(bodyFormData, this.props.token)
            .then(res => {
                this.setState({
                    dataKMS: {
                        ...this.state.dataKMS,
                        id: getContent(res).Id.Int64,
                    },
                    showConfirmAlert: false,
                    showSuccessAlert: true,
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    successAddCategoryKMS = () => {
        this.setState({ showSuccessAlert: false });
        if (this.state.checkboxAddKMS) {
            return this.props.history.push({ pathname: ROUTER_CONSTANT.SETTINGS_KMS_LIST_ADD, state: { categoryKMSDetail: this.state.dataKMS } });
        }
        this.props.history.push(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY);
    }

    getBooleanData = value => {
        if (value === "false") {
            return false;
        }
        return true;
    }

    disableCheckbox = value => {
        if (value === "false") {
            return true;
        }
        return false;
    }

    confirmationDescription = () => {
        return (
            <div className="space-y-3">
                <p>Data otomatis akan tersimpan di KMS</p>
                <div className="flex justify-center items-center space-x-2">
                    <input id="ckbaddkms" type="checkbox" disabled={this.disableCheckbox(this.state.dataKMS.lastLevel)} onChange={this.handleCheckboxAddKMS} />
                    <label className={this.disableCheckbox(this.state.dataKMS.lastLevel) ? "text-gray-400" : "text-gray-700"}>Tambah daftar KMS</label>
                </div>
            </div>
        )
    }

    getParentListByLevel = (current, pageSize, level) => {
        API_KMS.getParentListByLevel(current, pageSize, level, this.props.token).then(
            res => {
                let tempParentIdList = getContent(res).map(categoryKMS => ({
                    value: categoryKMS.id,
                    label: categoryKMS.category
                }))
                this.setState({ parentIdList: tempParentIdList });
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_KMS_INSERT]} userPermission={this.props.userDetail.permissions}>
                <div ref={this.containerRef} className="space-y-3">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="KMS"
                        menuItem="Tambah Kategori KMS"
                        title="Knowledge Management Sistem"
                    />

                    {/* WHITECONTAINER */}
                    <div className="white-container pb-24">
                        <div className="w-full bg-white border border-gray-300 rounded-lg p-8">
                            {/* MENU HEADBAR */}
                            <div className="flex items-center space-x-5 text-2xl text-gray-700 pb-10">
                                <button className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY_ADD) ? "active-menu-kms font-medium" : "font-medium"}>
                                    Kategori KMS
                                </button>
                                <button className={`
                                ${window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_LIST) ? "active-menu-kms font-medium" : "font-medium"}
                                ${this.state.disableKMSListMenu ? "text-gray-400 cursor-default" : "cursor-pointer"}
                            `}
                                    disabled={this.state.disableKMSListMenu}
                                >
                                    Daftar KMS
                                </button>
                            </div>
                            {/* CONTENT  MENU */}
                            <div className="relative">
                                {/* Form */}
                                <div className="space-y-4">
                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Kategori KMS</p>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <input
                                            id="tslcategorykms"
                                            type="text"
                                            name="category"
                                            placeholder="Tulis Kategori KMS"
                                            className="form-control w-full"
                                            onChange={this.handleChange}
                                            maxLength={256}
                                        />
                                        {this.state.showAlertKMSCategory && <MasterDataUserAlert text="Kategori KMS tidak boleh kosong!" />}
                                        {this.state.showAlertKMSCategoryRegex && <MasterDataUserAlert text="Kategori KMS tidak boleh mengandung spesial karakter" />}
                                        {this.state.showAlertKMSCategoryMaxChar && <MasterDataUserAlert text="Jumlah karakter harus lebih kecil dari 256" />}
                                    </div>

                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Tipe</p>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <Select
                                            inputId="ddltype"
                                            name="type"
                                            options={MENU_KMS.typeOptions}
                                            placeholder="Pilih Tipe"
                                            components={{ IndicatorSeparator: () => null }}
                                            className="w-full"
                                            maxMenuHeight={170}
                                            onChange={this.handleChangeType}
                                        />
                                        {this.state.showAlertType && <MasterDataUserAlert text="Tipe tidak boleh kosong!" />}
                                    </div>

                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Level</p>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <Select
                                            inputId="ddllevel"
                                            name="level"
                                            options={MENU_KMS.levelOptions}
                                            placeholder="Pilih Level"
                                            components={{ IndicatorSeparator: () => null }}
                                            className="w-full"
                                            maxMenuHeight={170}
                                            onChange={this.handleChangeLevel}
                                        />
                                        {this.state.showAlertLevel && <MasterDataUserAlert text="Level tidak boleh kosong!" />}
                                    </div>

                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Parent</p>
                                            <span className={this.state.dataKMS.level.value === 1 || this.state.dataKMS.level.value === "" ? "hidden" : "text-darkred"}>*</span>
                                        </div>
                                        <Select
                                            inputId="ddsparentcategory"
                                            name="parentId"
                                            options={this.state.parentIdList}
                                            value={this.state.dataKMS.parentId}
                                            placeholder="Pilih Parent"
                                            components={{ IndicatorSeparator: () => null }}
                                            className="w-full"
                                            maxMenuHeight={170}
                                            onChange={this.handleChangeParent}
                                            isDisabled={this.state.dataKMS.level.value === 1 ? true : false}
                                        />
                                        {(this.state.dataKMS.level.value !== 1 && this.state.showAlertParent) && <MasterDataUserAlert text="Parent tidak boleh kosong!" />}
                                    </div>

                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Icon</p>
                                        </div>
                                        {!this.state.dataKMS.iconFile ?
                                            <div className="flex justify-center items-center outline-none border-2 border-gray-300 border-dashed p-5 focus:outline-none">
                                                <div className="flex flex-col items-center w-full relative space-y-2 text-center text-gray-600">
                                                    <IconKMSUpload />
                                                    <p className="font-bold text-xl">Tarik dan letakkan gambar disini</p>
                                                    <p className="">Jenis file : JPG</p>
                                                    <p className="font-semibold">Atau</p>
                                                    <button className="bg-olddarkblue text-white px-2 py-1 rounded-lg font-medium">Cari File</button>
                                                    <input id="btnattachfile" type="file" className="w-full h-full absolute top-0 left-0 opacity-0" accept="image/png, image/jpg, image/jpeg" onChange={this.handleChangeAttachment} />
                                                </div>
                                            </div>
                                            :
                                            <div className="flex justify-between p-2 rounded-lg shadow-box-button bg-gray-100 text-gray-600">
                                                <div className="flex items-center">
                                                    <div className="mr-2">
                                                        <IconKMSImageIcon />
                                                    </div>
                                                    <div className="w-52">
                                                        <p className="text-lg truncate" title={this.state.dataKMS.iconFile.name}>{this.state.dataKMS.iconFile.name}</p>
                                                        <p className="text-sm">{Math.round(this.state.dataKMS.iconFile.size / 1024 / 1024 * 100) / 100} MB</p>
                                                        <p id="btnviewpicture" className="cursor-pointer text-blue-500" onClick={() => this.setState({ showPopupImage: true })}>Lihat Icon</p>
                                                    </div>
                                                </div>
                                                <div className="flex justify-end mt-1 mr-3">
                                                    <FontAwesomeIcon icon={faTimes} className="text-2xl cursor-pointer" onClick={() => { this.setState({ dataKMS: { ...this.state.dataKMS, iconFile: null } }) }} />
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Kategori Terkecil</p>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <RadioTab id="tglsmallestcategory" radioInputName="lastLevel" dataOption={MENU_KMS.dataLastLevel} defaultCheck={this.state.dataKMS.lastLevel} onChange={this.handleCheck} />
                                    </div>

                                    <div className="w-3/12 space-y-1">
                                        <div className="flex font-bold">
                                            <p className="mr-1">Status</p>
                                            <span className="text-darkred">*</span>
                                        </div>
                                        <RadioTab id="tglstatus" radioInputName="status" dataOption={MENU_KMS.dataStatus} defaultCheck={this.state.dataKMS.status} onChange={this.handleCheck} />
                                    </div>
                                </div>

                                {/* Button */}
                                <div className="flex space-x-5 absolute -bottom-24 -right-8">
                                    <button id="btncancel" className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={this.redirectToKMSPage}>Batal</button>
                                    <button id="btnsave" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={this.handleSave}>Simpan</button>
                                </div>

                                {/* Popup Modal Image */}
                                <div className={this.state.showPopupImage ? "block" : "hidden"}>
                                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-5/12 min-w-min">
                                            <div className="body-attachment w-full flex rounded-lg flex-col p-8 font-bold text-lg space-y-5">
                                                <div>
                                                    <div className="text-2xl">{this.state.dataKMS.iconFile ? this.state.dataKMS.iconFile.name : ""}</div>
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    <img src={this.state.dataKMS.iconFile && URL.createObjectURL(this.state.dataKMS.iconFile)} alt={this.state.dataKMS.iconFile ? this.state.dataKMS.iconFile.name : ""} className="h-96" />
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    <button id="btncloseviewicon" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showPopupImage: false })}>Tutup</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                </div>

                                {/* Alert */}
                                <Alert show={this.state.showConfirmAlert} button={true} title="Tambah Kategori?" desc={this.confirmationDescription()} close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleAddCategoryKMS()} />
                                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil disimpan!"} close={this.successAddCategoryKMS} ok />
                                <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                            </div>
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSCategoryAdd);